import React from "react";
import { AdministrateResourceDeleteButton } from "../../components/AdministrateResourceDeleteButton";
import { useTableContext } from "../../components/AdministrateTable";
import { History } from "../../tools/sandbox/release/History";
import { useDestroyPermission, useUpdatePermission } from "../../utils";
import { EditNonCoveredPricingModal } from "./EditNonCoveredPricingModal";

export const NonCoveredPricingActionCell = ({ row }) => {
  const { refresh, setMessage, setError } = useTableContext();
  const [canDestroy] = useDestroyPermission("NonCoveredPricing", row.original.id);
  const [canUpdate] = useUpdatePermission("NonCoveredPricing", row.original.id);

  const handleChange = (msg) => {
    setMessage(`Updated Non-Covered Pricing for CPT Code  ${row.original.cptCode.code}`);
    refresh();
  };

  return (
    <>
      {canUpdate && <EditNonCoveredPricingModal color="link" onEdit={handleChange} nonCoveredPricing={row.original} />}
      {canDestroy && (
        <AdministrateResourceDeleteButton
          deleteUrl={`/admin/non_covered_pricings/${row.original.id}`}
          onSuccess={() => {
            refresh();
            setMessage(`Deleted Non-Covered Pricing for CPT Code ${row.original.cptCode.code}`);
          }}
          onError={(msg) => setError(msg)}
        />
      )}
      <History entityName="NonCoveredPricing" subjectId={row.original.id} />
    </>
  );
};
